import React from "react";
import { trans } from "./../../Lang";
import { NavLink } from "react-router-dom";

export default class Tab extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { onChange, active } = this.props;

    return (
      <div className="auth-tab">
        <div
          className={`${active == "smile" ? "active" : ""} tab-item`}
          onClick={(e) => onChange("smile")}
        >
          Akun Smile
        </div>
        <div
          className={`${active == "email" ? "active" : ""} tab-item`}
          onClick={(e) => onChange("email")}
        >
          Tamu
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/components/Tab.js